import { getRequest, patchRequest, postRequest, putRequest } from "utils/helpers/common/http-methods";

export const BUSINESS_MANAGEMENT_APIS = {
  getBusinessList: (params: any) => getRequest("/host/businesses-list", params),
  getBusinessDetailById: (id: number) => getRequest(`/auth/user/${id}/details`),
  activateMember: (userId: number) => patchRequest(`users/${userId}/enable`, {}),
  deactivateMember: (userId: number) =>patchRequest(`users/${userId}/disable`, {}),
};
